//FishboneExample.jsx (Fishbones List)
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faFishFins, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import FishboneInfoGraphics from './FishboneInfoGraphics';
import FishboneInfographics1Image from '../../fivewhystemplates/FishboneInfographics1.png';


const FishboneExample = () => {
  const location = useLocation();
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();

  const [userId, setUserId] = useState(authState.user._id);
  const [fishbones, setFishbones] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [tags, setTags] = useState('');
  const [selectedFishboneId, setSelectedFishboneId] = useState(null);

const fetchFishbones = useCallback((fishboneType) => {
  const config = {
      url: "/fishbone/example",
      method: "post",
      headers: { Authorization: authState.token }
  };
  
  fetchData(config, { showSuccessToast: false })
      .then(response => {
          // console.log("Response:", response);
          if (response && Array.isArray(response.fishbones)) {
              setFishbones(response.fishbones);
          } else {
              console.error("Invalid response format: fishbone not found in response");
          }
      })
      .catch(error => {
          console.error("Error fetching fishbones:", error);
      });
}, [authState.token, fetchData]);

 useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchFishbones();
  }, [authState.isLoggedIn, fetchFishbones]);

  const handleView = (fishboneId) => {
    setSelectedFishboneId(prevId => (prevId === fishboneId ? null : fishboneId));
  };

  const handleCloseFishboneDetails = () => {
    setSelectedFishboneId(null);
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const handleSearch = () => {
    // Implement search functionality
  };

  const handleFishboneClick = (fishboneId) => {
    setSelectedFishboneId(fishboneId);
  };

  const handleFishboneShare = (fishboneId) => {
    setSelectedFishboneId(fishboneId);
  };

  const handleFishboneSave = (fishboneId) => {
    setSelectedFishboneId(fishboneId);
  };

  const handleFishbonePrint = (fishboneId) => {
    setSelectedFishboneId(fishboneId);
  };

  const formatDate = (date) => {
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatDateTime = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

  const sortedFishbones = [...fishbones].sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));

  const [fishbone1, setFishbone1]=useState(false);
  const handleFishbone1 = () => {
    setFishbone1(prevState => !prevState);
  };

  const handleAddNew = () => {
    navigate("/fishbone/add");
  };

  return (
    <div className='bg-black [&_p]:text-white'>
        <div className='mb-2'>
            <h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Fishbone List</h3>
        </div>
        <>
        <div className="my-2 mx-auto max-w-[700px] py-4">
          <div className="border border-gray-300 p-4 mt-4">
            <div className="mt-2">
              <div className="mt-2">
                {fishbones && fishbones.length !== 0 && (
                  <div className="flex justify-between items-center border-b border-b-gray-300">
                    <h3 className='text-xl mt-1 mx-2 text-white'>{fishbones.length} Example Fishbones Found!</h3>
                </div>
                )}
              </div>
            </div>
            {loading ? (
              <Loader />
            ) : (
              <div>
                {fishbones && fishbones.length === 0 ? (
                  <div className='flex flex-col items-center justify-center h-full text-yellow-300'>
                    <h3 className='text-xl mt-1 mx-2 text-orange-400'>No Example Record Found!</h3>
                  </div>
                ) : (
                  sortedFishbones.map((fishbone, index) => (
                    <div key={fishbone._id} className='bg-white my-4 p-4 text-gray-600 rounded-md shadow-md'>
                      <div className='flex'>
                        <span className='font-medium'>{fishbone.category}</span>
                        <Tooltip text={"View details"} position={"top"}>
                          <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleView(fishbone._id)}>
                            <i className="fa-solid fa-eye"></i>
                          </span>
                        </Tooltip>
                      </div>
                      <div className='whitespace-pre  text-blue-700'>{fishbone.problemTitle}</div>
                      {selectedFishboneId === fishbone._id && (
                        <div className='bg-gray-200 text-black'>
                          <h2 className='text-blue-600'><strong>Fishbone</strong></h2>
                          <p><strong>Problem Statement:</strong> {fishbone.problemTitle}</p>
                          <p><strong>Date Created:</strong> {formatDateTime(fishbone.dateCreated)}</p>
                          <div className='ml-4 mt-4 mb-4'>
                            <Tooltip text={"fishbone1"} position={"top"}>
                              <span className='text-red-500 cursor-pointer mr-2 mb-2 text-2xl' onClick={() => handleFishbone1(fishbone._id, 1)}>
                                <FontAwesomeIcon icon={faFishFins} />
                              </span>
                            </Tooltip>
                            {fishbone1 && (
                              <FishboneInfoGraphics
                                  title={fishbone.problemTitle}
                                  problem={fishbone.problem.short}
                                  cat1={fishbone.cat1?.name || ''}
                                  cat2={fishbone.cat2?.name || ''}
                                  cat3={fishbone.cat3?.name || ''}
                                  cat4={fishbone.cat4?.name || ''}
                                  cat5={fishbone.cat5?.name || ''}
                                  cat6={fishbone.cat6?.name || ''}
                                  cat1cause1={fishbone.cat1?.causes[0]?.name || ''}
                                  cat1cause2={fishbone.cat1?.causes[1]?.name || ''}
                                  cat2cause1={fishbone.cat2?.causes[0]?.name || ''}
                                  cat2cause2={fishbone.cat2?.causes[1]?.name || ''}
                                  cat3cause1={fishbone.cat3?.causes[0]?.name || ''}
                                  cat3cause2={fishbone.cat3?.causes[1]?.name || ''}
                                  cat4cause1={fishbone.cat4?.causes[0]?.name || ''}
                                  cat4cause2={fishbone.cat4?.causes[1]?.name || ''}
                                  cat5cause1={fishbone.cat5?.causes[0]?.name || ''}
                                  cat5cause2={fishbone.cat5?.causes[1]?.name || ''}
                                  cat6cause1={fishbone.cat6?.causes[0]?.name || ''}
                                  cat6cause2={fishbone.cat6?.causes[1]?.name || ''}
                                  fontSize={11}
                                  lineHeight={15}
                                  maxWidth={25}
                                  
                                  startXProblem={100}
                                  startYProblem={10}

                                  startXTitle={515}
                                  startYTitle={290}

                                  startXCat1={90}
                                  startYCat1={180}
                                  startXCat2={200}
                                  startYCat2={180}
                                  startXCat3={300}
                                  startYCat3={180}
                                  startXCat4={90}
                                  startYCat4={410}
                                  startXCat5={200}
                                  startYCat5={410}
                                  startXCat6={300}
                                  startYCat6={410}
                                  
                                  startXCat1Cause1={150}
                                  startYCat1Cause1={260}
                                  startXCat2Cause1={250}
                                  startYCat2Cause1={260}
                                  startXCat3Cause1={350}
                                  startYCat3Cause1={260}

                                  startXCat1Cause2={200}
                                  startYCat1Cause2={200}
                                  startXCat2Cause2={300}
                                  startYCat2Cause2={200}
                                  startXCat3Cause2={400}
                                  startYCat3Cause2={200}

                                  startXCat4Cause1={200}
                                  startYCat4Cause1={350}
                                  startXCat5Cause1={300}
                                  startYCat5Cause1={370}
                                  startXCat6Cause1={410}
                                  startYCat6Cause1={370}

                                  startXCat4Cause2={150}
                                  startYCat4Cause2={310}
                                  startXCat5Cause2={250}
                                  startYCat5Cause2={310}
                                  startXCat6Cause2={350}
                                  startYCat6Cause2={310}
                                  imageSrc={FishboneInfographics1Image}
                                  viewWidth={800}
                              />
                            )}
                          </div>
                          <div className='mt-4'>
                            <h3 className='text-lg font-bold text-blue-500'>Problem Details</h3>
                            <p><strong>Short Description:</strong> {fishbone.problem.short}</p>
                            <p><strong>Description:</strong> {fishbone.problem.description}</p>
                            <p><strong>Remarks:</strong> {fishbone.problem.remarks}</p>
                          </div>

                          {[fishbone.cat1, fishbone.cat2, fishbone.cat3, fishbone.cat4, fishbone.cat5, fishbone.cat6].map((category, index) => (
                            category && (
                              <div key={index} className='mt-4'>
                                <h3 className='text-lg font-bold text-purple-500'>{index+1}. {category.name} (Shortcode: {category.shortcode})</h3>
                                {category.causes.map((cause, causeIndex) => (
                                  <div key={causeIndex} className='ml-4 mt-2'>
                                    <h4 className='text-md font-semibold text-teal-500'>{causeIndex+1}. {cause.name} (Shortcode: {cause.shortcode})</h4>
                                    <p><strong>Details:</strong> {cause.details}</p>
                                    <p><strong>Count:</strong> {cause.count}</p>
                                    <p><strong>Weightage:</strong> {cause.weightage}</p>
                                    <p><strong>Solution:</strong> {cause.solution}</p>
                                    <p><strong>Why Code:</strong> {cause.whyCode}</p>
                                    <p><strong>Remarks:</strong> {cause.remarks}</p>

                                    {cause.subcauses.length > 0 && (
                                      <div className='ml-4 mt-2'>
                                        <h5 className='text-sm font-semibold'>Subcauses:</h5>
                                        {cause.subcauses.map((subcause, subcauseIndex) => (
                                          <div key={subcauseIndex} className='ml-2 mt-1'>
                                            <h6 className='text-sm font-medium text-orange-400'>{subcauseIndex+1}. {subcause.name} (Shortcode: {subcause.shortcode})</h6>
                                            <p><strong>Details:</strong> {subcause.details}</p>
                                            <p><strong>Count:</strong> {subcause.count}</p>
                                            <p><strong>Weightage:</strong> {subcause.weightage}</p>
                                            <p><strong>Solution:</strong> {subcause.solution}</p>
                                            <p><strong>Why Code:</strong> {subcause.whyCode}</p>
                                            <p><strong>Remarks:</strong> {subcause.remarks}</p>
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            )
                          ))}
                        </div>
                      )}
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
      </div>
        </>
    </div>
  )
}

export default FishboneExample;
